import styled from "styled-components";

export const AdminContainer = styled.div`
  width: 88%;
  height: 100vh;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 240px 1fr;
  grid-template-rows: auto auto 1fr 32px;
`;

export const HeaderContainer = styled.div`
  grid-column: 1 / -1;
  grid-row: 1 / 2;
  border-bottom: 2px solid ${props => props.theme.color.lightGray};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
`;

export const NavigatorContainer = styled.div`
  grid-column: 1 / -1;
  grid-row: 2 / 3;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LayoutContainer = styled.div`
  grid-column: 1 / -1;
  grid-row: 3 / 4;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const FooterContainer = styled.div`
  grid-column: 1 / -1;
  grid-row: 4 / -1;
`;